import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDocsByAdmin } from '../../api/aprvDoc'; // ✅ 관리자용 결재문서 조회 API
import { formatDate, docStatusMap } from '../../utils/commonUtils';

function AprvDocListByAdmin() {
  const [docs, setDocs] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [status, setStatus] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const currentPage = parseInt(queryParams.get('page')) || 1;

  const docsPerPage = 10;
  const totalPages = Math.ceil(total / docsPerPage);
  const token = sessionStorage.getItem('token');

  // 📑 문서 목록 조회
  const fetchDocs = useCallback(
    async (page, keyword = '', status = '') => {
      try {
        const { docs: fetchedDocs, total: fetchedTotal } = await getDocsByAdmin(
          page,
          docsPerPage,
          keyword,
          status,
          token,
        );
        setDocs(fetchedDocs);
        setTotal(fetchedTotal);
      } catch (err) {
        console.error('관리자용 문서 목록 조회 실패:', err);
      }
    },
    [docsPerPage, token]
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get('page')) || 1;
    const keyword = params.get('search') || '';
    const status = params.get('status') || '';
    setSearchTerm(keyword);
    setStatus(status);
    fetchDocs(page, keyword, status);
  }, [location.search, fetchDocs]);

  // 📑 검색 처리
  const handleSearch = (e) => {
    e.preventDefault();
    const keyword = e.target.search.value.trim();
    setSearchTerm(keyword);
    navigate(`/aprvdoc/admin?page=1&search=${keyword}${status ? `&status=${status}` : ''}`);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">

          {/* 헤더 영역 */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">📋 관리자용 결재문서 목록</h4>
          </div>

          {/* 검색 + 상태 필터 */}
          <form className="row g-2 mb-3" onSubmit={handleSearch}>
            <div className="col-md-4">
              <input
                type="text"
                name="search"
                className="form-control"
                placeholder="제목 또는 기안자 검색"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  navigate(`/aprvdoc/admin?page=1&search=${searchTerm}&status=${e.target.value}`);
                }}
              >
                <option value="">전체 상태</option>
                <option value="draft">임시저장</option>
                <option value="request">상신</option>
                <option value="reject">반려</option>
                <option value="complete">완료</option>
              </select>
            </div>
            <div className="col-auto">
              <button className="btn btn-outline-secondary" type="submit">검색</button>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-outline-danger"
                type="button"
                onClick={() => {
                  setSearchTerm('');
                  setStatus('');
                  navigate(`/aprvdoc/admin?page=1`);
                }}
              >
                초기화
              </button>
            </div>
          </form>

          {/* 결재문서 목록 */}
          {docs.length === 0 ? (
            <div className="text-center text-muted mt-5">
              <p>결재문서가 없습니다.</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-nowrap align-middle table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '20%' }}>결재양식</th>
                      <th style={{ width: '30%' }}>제목</th>
                      <th className="text-center" style={{ width: '15%' }}>기안자</th>
                      <th className="text-center" style={{ width: '15%' }}>기안일</th>
                      <th className="text-center" style={{ width: '20%' }}>문서 상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    {docs.map((doc) => (
                      <tr
                        key={doc.aprv_id}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          navigate(`/aprvdoc/view/${doc.aprv_id}?page=${currentPage}&search=${searchTerm}${status ? `&status=${status}` : ''}`);
                        }}
                      >
                        <td>{doc.form_name}</td>
                        <td>
                          <h5 className="font-size-14 mb-0">{doc.title}</h5>
                        </td>
                        <td className="text-center">{doc.user_name}</td>
                        <td className="text-center text-muted">{formatDate(doc.req_date)}</td>
                        <td className="text-center">
                          {docStatusMap[doc.doc_status] || doc.doc_status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ✅ 페이지네이션 */}
              <nav className="mt-4">
                <ul className="pagination justify-content-center">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          navigate(`/aprvdoc/admin?page=${i + 1}&search=${searchTerm}${status ? `&status=${status}` : ''}`)
                        }
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AprvDocListByAdmin;